<button id="dptoggle" data-test="date-picker-toggle-button" class="btn btn-icon icon-tertiary" (click)="d.toggle()">
  <flo-svg-icon class="grey-600" icon="calendar-alt" width="20px" height="20px"></flo-svg-icon>
</button>
<input
     type="hidden"
     name="dp"
     [formControl]="datePickerFormControl"
     ngbDatepicker
     #d="ngbDatepicker"
     [minDate]="minDate"
     [maxDate]="maxDate"
     [startDate]="startDate"
     outsideDays="collapsed"
     firstDayOfWeek="7"
     [dayTemplate]="customDay"
     positionTarget="#dptoggle"
     [placement]="placement"
     restoreFocus="false"
>
<ng-template
  #customDay
  let-date
  let-disabled="disabled"
  let-selected="selected"
  let-focused="focused"
>
  <div
    data-test="custom-template"
    class="position-relative display-flex align-items-center"
    [class.focused]="focused"
    [class.active]="selected"
    [class.disabled]="disabled"
  >
  <span class="custom-day">
    {{ date.day }}
  </span>
  </div>
</ng-template>
